export enum NOTA_CREDITO_EXTERNO_TYPES {
    NCE_SET_VIEW = 'NCE_SET_VIEW',
    NCE_SET_FORM_CLIENTE = 'NCE_SET_FORM_CLIENTE',
    NCE_HANDLE_ERRORS_CLIENTE = 'NCE_HANDLE_ERRORS_CLIENTE',
    NCE_SET_FORM_PRODUCTO = 'NCE_SET_FORM_PRODUCTO',
    NCE_HANDLE_ERRORS_PRODUCTO = 'NCE_HANDLE_ERRORS_PRODUCTO',
    NCE_SET_PRODUCTOS = 'NCE_SET_PRODUCTOS',
    NCE_SET_PRODUCTO_EDIT = 'NCE_SET_PRODUCTO_EDIT',
    NCE_SET_PRODUCTO_INDEX = 'NCE_SET_PRODUCTO_INDEX',

    NCE_ACTIVE_MODAL_EDITAR_PRODUCTO = 'NCE_ACTIVE_MODAL_EDITAR_PRODUCTO',
    NCE_ACTIVE_MODAL_ELIMINAR_PRODUCTO = 'NCE_ACTIVE_MODAL_ELIMINAR_PRODUCTO',
    NCE_ACTIVE_MODAL_QUITAR_TODO = 'NCE_ACTIVE_MODAL_QUITAR_TODO',
    NCE_ACTIVE_MODAL_EMITIR = 'NCE_ACTIVE_MODAL_EMITIR',
    NCE_ACTIVE_MODAL_EMITIDO = 'NCE_ACTIVE_MODAL_EMITIDO',
    NCE_ACTIVE_MODAL_MAS_OPCIONES = 'NCE_ACTIVE_MODAL_MAS_OPCIONES',
    NCE_ACTIVE_MODAL_ENVIAR_CORREO = 'NCE_ACTIVE_MODAL_ENVIAR_CORREO',
    NCE_ACTIVE_MODAL_IMPRIMIR = 'NCE_ACTIVE_MODAL_IMPRIMIR',
    NCE_ACTIVE_MODAL_ANULAR = 'NCE_ACTIVE_MODAL_ANULAR',
    NCE_ACTIVE_MODAL_ANULADO = 'NCE_ACTIVE_MODAL_ANULADO',

    NCE_SET_QR_CODE = 'NCE_SET_QR_CODE',
    NCE_SET_RESPONSE_EMITIR = 'NCE_SET_RESPONSE_EMITIR',

    NCE_SET_CALCULOS_PRODUCTO = 'NCE_SET_CALCULOS_PRODUCTO',
    NCE_SET_CALCULOS_GENERALES = 'NCE_SET_CALCULOS_GENERALES',

    NCE_RESTART_FORM_PRODUCTO = 'NCE_RESTART_FORM_PRODUCTO',
    NCE_RESTART_ALL = 'NCE_RESTART_ALL',
    NCE_SET_CLIENTE_ENCONTRADO = 'NCE_SET_CLIENTE_ENCONTRADO',
    NCE_ACTIVE_MODAL_CLIENTE_ENCONTRADO = 'NCE_ACTIVE_MODAL_CLIENTE_ENCONTRADO',
    NCE_SET_TABLE_PRODUCTOS = 'NCE_SET_TABLE_PRODUCTOS',
    NCE_SET_RETENCION_RENTA = 'NCE_SET_RETENCION_RENTA',
    NCE_ACTIVE_MODAL_DOCUMENTO_FISICO = 'NCE_ACTIVE_MODAL_DOCUMENTO_FISICO',
    NCE_SET_DOCUMENTO_FISICO = 'NCE_SET_DOCUMENTO_FISICO',
    NCE_ACTIVE_MODAL_DESCUENTO = 'NCE_ACTIVE_MODAL_DESCUENTO',
    NCE_SET_PRODUCTO_DESCUENTO = 'NCE_SET_PRODUCTO_DESCUENTO',
    NCE_SET_PRODUCTOS_CHANGE_IVA = 'NCE_SET_PRODUCTOS_CHANGE_IVA',
}
